module.exports = __webpack_public_path__ + "static/media/bg-card-on.a5c2a7d9.png";